<template>
	<div class="c-districtofficeblock__wrapper">
		<div class="c-districtofficeblock__inner">
			<div class="c-districtofficeblock--icon">
				<v-icon :name="icon" size="lg" />
			</div>
			<div class="c-districtofficeblock__inner--information">
				<div class="c-districtofficeblock__name">{{ name }}</div>
				<div class="c-districtofficeblock__adress">{{ adress }}</div>
				<div class="c-districtofficeblock__link">
					<a :href="url">Se kontorets öppettider</a>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import VIcon from "../../components/icon/VIcon.vue";
export default {
	name: "VDistrictOfficeBlock",
	components: {
		VIcon
	},
	props: {
		name: {
			type: String,
			default: ''
		},
		adress: {
			type: String,
			default: ''
		},
		url: {
			type: String,
			default: ''
		},
		icon: {
			type: String,
			default: "neighborhood"
		}
	},
	data() {
		return {
			
		};
	},
	mounted() {

	},
	beforeDestroy() {

	}
};
</script>
